import React, { useEffect } from "react";
import Address from "../../../components/Address";
import { AdminMenuBar } from "../../../components/admin/AdminMenuBar";
import { AdminPost } from "../../../components/admin/customer_support/AdminPost";
import { checkSession } from "../../../services/Admin";
import { postByAdmin } from "../../../services/CustomerAPI";
import "../../ContentFrame.css";
import "../../Main.css";

export const AdminPostForm = () => {
    useEffect(() => {
        checkSession();
    }, []);

    const goList = () => {
        window.location.href = "/admin/sales?page=1";
    };

    const post = (data, file) => {
        postByAdmin(data, file, "SALE");
    };

    return (
        <div>
            <AdminMenuBar selected_page={5} />
            <div className="w-full h-full bg-white">
                <div className="common_frame_container">
                    <div className="common_content_container">
                        <div style={{ width: "100%", height: "100px" }}></div>
                        <span className="content_title">영업상담</span>
                        <div className="title_line" style={{ width: "145px" }}></div>
                        <AdminPost post={post} goList={goList} type="SALE" />
                        <div style={{ width: "100%", height: "100px" }}></div>
                    </div>
                </div>
            </div>
            <Address />
        </div>
    );
};
